import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { CONTACT_EMAIL, BLOG_URL } from "@/data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-kiki-surface/60 border-t border-kiki-line overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
      <div className="flex flex-col lg:flex-row justify-between gap-12">
        <div className="max-w-sm">
          <p className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Kiki Services logo" className="w-10 h-10 rounded-full object-cover border border-kiki-line" />
            <span className="font-display text-3xl text-kiki-ink">Kiki<span className="italic text-kiki-gold">Services</span></span>
          </p>
          <p className="mt-4 text-sm text-kiki-muted leading-relaxed font-light">
            Practical HR, payroll, business process, data, brand, digital,
            documentation, change-management and operations support for startups,
            SMEs, founders and growing businesses.
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-kiki-muted mb-4">Explore</p>
            <div className="space-y-2.5">
              {[["services", "Services"], ["store", "Digital Store"], ["ways", "Ways to Work"], ["blog", "Blog"]].map(([id, label]) => (
                <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="block text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                  {label}
                </button>
              ))}
              <Link data-testid="footer-link-booking" to="/book" className="block text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                Booking
              </Link>
              <Link data-testid="footer-link-testimonials" to="/testimonials" className="block text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                Testimonials
              </Link>
              <Link data-testid="footer-link-about" to="/about" className="block text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                About
              </Link>
              <Link data-testid="footer-link-privacy" to="/privacy" className="block text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                Privacy Policy
              </Link>
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-kiki-muted mb-4">Engage</p>
            <div className="space-y-2.5">
              <a data-testid="footer-email-link" href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-1 text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                Email us <ArrowUpRight className="w-3 h-3" />
              </a>
              <p data-testid="footer-email-address" className="text-xs text-kiki-muted/70 font-mono">{CONTACT_EMAIL}</p>
              <a data-testid="footer-blog-link" href={BLOG_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-sm text-kiki-muted hover:text-kiki-gold transition-colors duration-300">
                HRM Express blog <ArrowUpRight className="w-3 h-3" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <p aria-hidden className="font-display text-outline-soft text-[18vw] leading-none text-center select-none mt-12 -mb-4 font-medium tracking-tight">
        KIKI
      </p>

      <div className="border-t border-kiki-line pt-6 flex flex-col sm:flex-row justify-between gap-3">
        <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-widest text-kiki-muted/70">
          © 2026 Kiki Services · kikiservices.co.in
        </p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-kiki-muted/70">
          HR · Payroll · Consulting · Data · Brand · Digital
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
